/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportPermission
 */
export interface ReportPermission {
    /**
     * A report type
     * @type {string}
     * @memberof ReportPermission
     */
    name?: ReportPermissionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ReportPermission
     */
    permission?: ReportPermissionPermissionEnum;
}


/**
 * @export
 */
export const ReportPermissionNameEnum = {
    Passageline: 'passageline',
    Density: 'density',
    PassagelineHistogram: 'passageline_histogram',
    ShipReport: 'ship_report',
    AtonOverviewReport: 'aton_overview_report',
    AtonDetailedReport: 'aton_detailed_report',
    NearMissToPoint: 'near_miss_to_point',
    PssstatusOverviewReport: 'pssstatus_overview_report',
    PssstatusDetailedReport: 'pssstatus_detailed_report',
    DataPassageline: 'data_passageline',
    AisdataArea: 'aisdata_area',
    NearMissShipToShip: 'near_miss_ship_to_ship',
    CsvDataExport: 'csv_data_export',
    CoverageReport: 'coverage_report',
    WdeventReport: 'wdevent_report',
    ReplayVideoReport: 'replay_video_report',
    GenericSql: 'generic_sql',
    DataPassagelineMulti: 'data_passageline_multi',
    NearmissshiptoshipTb: 'nearmissshiptoship_tb',
    AreaStatTb: 'area_stat_tb',
    HistoryTrackTb: 'history_track_tb'
} as const;
export type ReportPermissionNameEnum = typeof ReportPermissionNameEnum[keyof typeof ReportPermissionNameEnum];

/**
 * @export
 */
export const ReportPermissionPermissionEnum = {
    Deny: 'Deny',
    View: 'View',
    All: 'All'
} as const;
export type ReportPermissionPermissionEnum = typeof ReportPermissionPermissionEnum[keyof typeof ReportPermissionPermissionEnum];


/**
 * Check if a given object implements the ReportPermission interface.
 */
export function instanceOfReportPermission(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReportPermissionFromJSON(json: any): ReportPermission {
    return ReportPermissionFromJSONTyped(json, false);
}

export function ReportPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
    };
}

export function ReportPermissionToJSON(value?: ReportPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'permission': value.permission,
    };
}

